import React, { useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { Dropdown } from 'semantic-ui-react'
import FormGroup from './FormGroup'
import { isOneDropdownOption } from '../../utils/fns'

import '../../globals/scss/components/dropdown-v2.scss'

const DropdownBlock = (props) => {
  const myRef = useRef(null)
  const inputFreeze = useSelector((state) => state.calculation.input.inputFreeze)
  const {
    warning,
    dropdownProps,
    name,
    value,
    options,
    label,
    popoverText,
    helpTextModal,
    onChange,
  } = props
  const [isUpward, setUpward] = useState(false)

  const handleChange = (e, option) => {
    onChange(option.name, option.value)
  }
  const handleFocus = (e) => {
    myRef.current.classList.add('-focused')
  }
  const handleBlur = (e) => {
    myRef.current.classList.remove('-focused')
  }

  const handleOpen = (e) => {
    myRef.current.classList.remove('-focused', 'upward')

    if (!myRef.current) return

    const dropdown = myRef.current.querySelector('.dropdown')
    const dropdownRect = dropdown.getBoundingClientRect()
    const menu = myRef.current.querySelector('div.menu')
    const inputSection = document.querySelector('div.inputSection')

    if (!menu) return

    const menuHeight = menu.clientHeight
    const spaceAtTheBottom =
      inputSection.clientHeight - dropdownRect.top - dropdownRect.height - menuHeight
    const spaceAtTheTop = dropdownRect.top - menuHeight

    const isUpward = spaceAtTheBottom < 0 && spaceAtTheTop > spaceAtTheBottom

    setUpward(isUpward)
  }

  return (
    <FormGroup
      ref={myRef}
      warning={warning}
      label={label}
      popoverText={popoverText}
      helpTextModal={helpTextModal}
    >
      <Dropdown
        fluid
        {...dropdownProps}
        name={name}
        upward={isUpward}
        value={value}
        options={options}
        disabled={inputFreeze || isOneDropdownOption(options)}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onOpen={handleOpen}
      />
    </FormGroup>
  )
}
export default DropdownBlock
